//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpContainer',
  props: {
    noTopPadding: { type: Boolean, default: false },
  },
};
